export const LandingPageInfo = [
    {
      title: "Who? - Users",
      subInfo: [
        { name: "Exporters/SMEs", description:'Quantify Global Demand/Cost Risks', link: `/who/${"exporters"}` },
        { name: "Consultancies",description:'Incorporate Coherent Global Analysis',link: `/who/${"consultancies"}`,},
        { name: "Investment/Fund Managers",description:'Explore Portfolio/Esg Risk',link: `/who/${"investment-managers"}`,},
        { name: "Energy/Emissions Analysts", description:'Test Emissions-Macro Sensitivities',link: `/who/${"energy-analysts"}` },
        { name: "Higher Education Institutions", description:'Real World Risk Models/Tools/Apps',link: `/who/${"higher-education-institutions"}`,},
      ],
    },
    {
        title: "Why? - Risk Mitigation",
        subInfo: [
          { name: "Ubiquitous Global Threats & Opportunites", description:'Global Economy - Multi-Dimensional Uncertainty',link: `/why/${"global-risk"}` },
          { name: "Scenario Analysis - for Strategic Planning", description:'Model-based Risk Quantification',link: `/why/${"scenario-analysis"}` },
          { name: "Carbon/Energy Transition Risks", description:'Highlighting Risks in Pathways/Policies to 2050',link: `/why/${"transition-risks"}` },
          { name: "", description:'spacer',link: `` },
          { name: "Risk Stories", description:'Case studies in Neglected Risk Management',link: `/RiskStories/${"RiskStoriesSubPage"}` },
          
        ],
      },
      {
        title: "What? - Tools/Apps",
        subInfo: [
          { name: "Pre-run Scenarios", description:'Test Sensitivities - Model-Based Scenarios',link: `/what/${"prerun-scenarios"}` },
          {
            name: "Bespoke - Scenarios & Models",
            description:'Quantify Macro, Energy & Portfolio Risk',link: `/what/${"bespoke-scenariosModels"}`,
          },
          { name: "risk2NZ App - for Business & Education", description:'Quantify Macro Risks to Net Zero',link: `/what/${"risk2NZ-app"}` },
          //      { name: "Bespoke Models", description:'',link: `/what/${"bespoke-models"}` },
        ],
      },
      {
        title: "How? - Global Models",
        subInfo: [
          { name: "mGEM-Global Macroeconomic Model", description:'Explore "Known-Unknowns" Macro Risks',link: `/how/${"mGEM-global-macro"}` },
          { name: "finGEM-Global Finance/Liquidity Model", description:'Explore & Quantify Portfolio/ESG Risks',link: `/how/${"finGEM-global-finance"}`,},
          { name: "eGEM-Global GHG Emissions Model", description:'Quantify Industry/Sector Emissions',link: `/how/${"eGEM-global-emissions"}`,},
          { name: "enGEM-Global Energy Model", description:'Explore Energy Demand/Supply; enGEM',link: `/how/${"enGEM-global-energy"}` },
          { name: "defGEM-Global Defence Spending Model", description:'Explore Drivers of MILEX with defGEM',link: `/how/${"defGEM-global-defence"}` },
          { name: "stuGEM-Global Student Flows to the UK", description:'Explore Drivers of UK inflows with stuGEM',link: `/how/${"stuGEM-global-students"}` },          
        ],
      },
]